<template>
	<el-dialog
		title="批量导入快捷短语"
		:visible.sync="visibleProxy"
		width="680px"
		append-to-body
		custom-class="fri-dialog"
		@closed="onClosed"
	>
		<div class="fri-row">
			<div class="fri-row-label">选择覆盖方式：</div>
			<el-radio-group v-model="importType" class="fri-radio">
				<el-radio label="increase">增量覆盖</el-radio>
				<el-radio label="override">全量覆盖</el-radio>
			</el-radio-group>
		</div>
		<div class="fri-row">
			<div class="fri-row-label">选择上传文件：</div>
			<input ref="fileInput" type="file" accept=".csv,.txt,.xls,.xlsx" class="fri-file" @change="onFileChange" />
			<el-button class="fri-upload-btn" size="small" @click="chooseFile"><i class="el-icon-upload2"></i> 添加文件</el-button>
			<div class="fri-file-name" v-if="fileName">{{ fileName }}</div>
		</div>
		<div class="fri-tips">
			<div>1、导入成功后会覆盖已添加内容，请谨慎操作（可先将现有内容导出）；</div>
			<div>2、不同分组有不同的模板，需分别导入。</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="visibleProxy=false">取消</el-button>
			<el-button type="primary" @click="onImportClick" :loading="importLoading">导入</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'FastReplyImportDDDialog',
	props: {
		visible: { type: Boolean, default: false },
		sceneId: { type: String, default: 0 },
	},
	data() {
		return {
			filePath: '',
			fileBlob: null,
			tableData: [],
			importType: 'override', // 新增：导入类型
			fileName: '', // 新增：文件名
			importLoading: false, // 新增：导入中状态
		};
	},
	computed: {
		visibleProxy: {
			get() { return this.visible; },
			set(v) { this.$emit('update:visible', v); }
		}
	},
	methods: {
		chooseFile() {
			this.$refs.fileInput && this.$refs.fileInput.click();
		},
		loadReplyList() {
			this.$http.post(API_ROOT.newcustomer + '/train/reply/search?type=1&sceneId=' + this.sceneId).then(res => {
				const result = res.data;
				if (result && result.success) {
					const typeList = Array.isArray(result.data && result.data.typeList) ? result.data.typeList : [];
					// 构建父级名称索引
					const idToItem = {};
					typeList.forEach(t => { idToItem[t.id] = t; });
					let index = 1;
					const rows = [];
					typeList.forEach(t => {
						const parentName = t.name;
						const replies = Array.isArray(t.replyList) ? t.replyList : [];
						replies.forEach(r => {
							rows.push({
								index: index++,
								code: r.quicktext || '',
								content: r.replytext || '',
								group: parentName,
								image: '',
								status: '完成'
							});
						});
					});
					this.tableData = rows;
				} else {
					this.$message({
						message: result.msg,
						type: 'error'
					});
				}
			}, err => {
				this.$message({
					message: '保存失败',
					type: 'error'
				});
			});
		},
		onFileChange(e) {
			const file = e && e.target && e.target.files ? e.target.files[0] : null;
			if (!file) return;
			this.fileBlob = file;
			this.fileName = file.name; // 仅记录文件，真正导入在“导入”按钮触发
		},
		onImportClick() {
			if (!this.fileBlob) {
				this.$message({
					message: '请选择要导入的文件',
					type: 'warning'
				});
				return;
			}
			this.importLoading = true;
			const formdata = new FormData();
			formdata.append('file', this.fileBlob);
			formdata.append('id', 'WU_FILE_0');
			formdata.append('name', this.fileBlob.name || '');
			formdata.append('type', this.fileBlob.type || '');
			formdata.append('lastModifiedDate', (this.fileBlob.lastModified ? new Date(this.fileBlob.lastModified) : new Date()).toLocaleString());
			formdata.append('size', this.fileBlob.size != null ? String(this.fileBlob.size) : '');


			this.$http.post(
				API_ROOT.newcustomer + '/simulationExercise/reply/importReply?importType=' + this.importType + '&sceneId=' + this.sceneId,
				formdata,{ headers: { 'Content-Type': 'multipart/form-data' }}
			).then(res => {
				var result = res.data;
				if (result.success) {
					this.$emit('refresh');
					this.loadReplyList();
					this.visibleProxy = false;
					this.$message({
						message: '导入成功',
						type: 'success'
					});
				} else {
					this.$message({
						message: result.msg,
						type: 'error'
					});
				}
			}, res => {
				this.$message({
					message: '导入失败',
					type: 'error'
				});
			}).finally(() => {
				this.importLoading = false;
			});
		},
		onDownloadTemplate() {
			this.$http.get(API_ROOT.newcustomer + '/simulationExercise/reply/downloadTemplate?sceneId=' + this.sceneId).then(res => {
				const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', '快捷短语模板.xlsx');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			}).catch(err => {
				this.$message({
					message: '下载模板失败',
					type: 'error'
				});
			});
		},
		onClosed() {
			this.fileBlob = null;
			this.fileName = '';
			this.importType = 'override';
			this.importLoading = false;
			if (this.$refs.fileInput) this.$refs.fileInput.value = '';
		}
	}
};
</script>

<style lang='less' scoped>
.fri-dialog {
	/deep/ .el-dialog__header {
		background-color: #2d6cf6;
		color: #fff;
		padding: 12px 20px;
	}
	/deep/ .el-dialog__title { color: #fff; font-weight: 600; }
	/deep/ .el-dialog__headerbtn .el-dialog__close { color: #fff; }
	/deep/ .el-dialog__body { padding: 18px 24px; }
}

.fri-row { display: flex; align-items: center; margin-bottom: 18px; }
.fri-row-label { width: 110px; color: #303133; font-size: 14px; }
.fri-radio /deep/ .el-radio { margin-right: 24px; }
.fri-file { display: none; }
.fri-upload-btn { padding: 8px 14px; }
.fri-file-name { margin-left: 12px; color: #606266; font-size: 13px; }
.fri-tips { color: #909399; font-size: 13px; line-height: 22px; margin-top: 12px; }
.fri-tips a { color: #2d6cf6; }
</style>





// WEBPACK FOOTER //
// ./src/page/train/FBT/components/FastReplyImportDDDialog.vue